import { createFileRoute } from '@tanstack/react-router';

import { DeliveriesPage } from '@/features/procurement/deliveries-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/deliveries')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <DeliveriesPage {...params} />;
}
